import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoaderOverlayProps {
  message?: string;
}

const LoaderOverlay: React.FC<LoaderOverlayProps> = ({ message = 'Loading, please wait...' }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center">
      <div className="flex flex-col items-center justify-center bg-[#20232a] border border-neutral-700 text-white px-8 py-6 rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.7)]">
        <Loader2 className="w-8 h-8 animate-spin text-indigo-400 mb-4" />
        <p className="text-sm text-gray-300">{message}</p>
      </div>
    </div>
  );
};

export default LoaderOverlay;
